import { CREATE_USER_ERROR, CREATE_USER_INIT, CREATE_USER_REQUEST, CREATE_USER_SUCCESS } from '../actions/UsersActions'

const initialState = {
	// createUserInFlight: {},
	createUser: {}
}

const UsersReducer = function (state = initialState, action) {
	switch (action.type) {
		case CREATE_USER_INIT: {
			return {
				...state,
				createUser: initialState.createUser
			}
		}
		case CREATE_USER_REQUEST: {
			// state.createUserInFlight[action.payload.operationId] = {
			//     loading: true
			// };
			// return {
			//     ...state,
			//     createUserInFlight: {...state.createUserInFlight}
			// }
			return {
				...state,
				createUser: { loading: true }
			}
		}
		case CREATE_USER_SUCCESS: {
			// state.createUserInFlight[action.payload.operationId] = {
			//     loading: false,
			//     data: action.payload.data
			// };
			// return {
			//     ...state,
			//     createUserInFlight: { ...state.createUserInFlight }
			// }

			return {
				...state,
				createUser: {
					loading: false,
					data: action.payload.data
				}
			}
		}
		case CREATE_USER_ERROR: {
			// state.createUserInFlight[action.payload.operationId] = {
			//     loading: false,
			//     error: action.payload.error
			// };
			// return {
			//     ...state,
			//     createUserInFlight: { ...state.createUserInFlight }
			// }

			return {
				...state,
				createUser: {
					loading: false,
					error: action.payload.error
				}
			}
		}
		default: {
			return {
				...state
			}
		}
	}
}

export default UsersReducer
